import React from 'react'

import './css_files/App.css'
import { Link, Navigate, useNavigate } from 'react-router-dom';
import './css_files/profile.css'
import axios from 'axios';
import { url } from '../weburl';



const DogCardList = (props) => {

    let navigate = useNavigate()
    const handleDelete = (e) => {
        e.preventDefault()
        axios
            .delete(`${url}api/dogs/${props.dog_id}`)
        console.log('deleting')
        navigate('/home')

            .catch((err) => {
                console.log("Error couldnt delete Dog");
                console.log(err.message);
            });

    }
    // console.log(props)

    // const { row_style,column_style, p_style } = colstyle;
    return (
        <div className='container-fluid align-items-center justify-content-start dog-card mb-5'>
            
            <div className='row align-items-center justify-content-start bg-white pt-2'>
                <div className='col-12  text-left  align-items-center justify-content-center w-100' >

                    <div className='  '>
                        {/* <p style={{ fontWeight: '400' }} className='smallrem m-0'> {props.dogname}</p> */}
                        <p className='brand-yellow-font my-0 text-wrap'>
                            {props.dogname}

                        </p>  </div>

                    <div className=' '>
                        <p style={{ fontWeight: '400', fontSize: "12px" }} className='smallrem'> {props.breed || "Breed Unknown"}</p>


                    </div>

                    <div className='row align-items-center justify-content-start px-3 py-1 pt-3'>
                        {/* <div className="col-md-3 align-items-end"> */}
                        <p style={{ fontWeight: '400' }} className='p-0 font-footer'>
                            {props.date_registered || "Date: Unkwown"}</p>


                        {/* </div> */}
                    </div>
                </div>
            </div >


        </div>

    )
}



export default DogCardList;